module.exports = __webpack_public_path__ + "img/img_4.10c45ba6.png";